module.exports = __webpack_public_path__ + "img/icon-account.759fc8c2.svg";